import { Button } from "@amzn/storm-ui";
import * as React from "react";

import {
    ModalFooterContainer,
    AccountPickerFooterWrapper,
} from "../common/styled.components";

export interface AccountPickerFooterProps {
    onUseAccount: () => void;
    isUseAccountButtonDisabled: boolean;
    isUseAccountButtonPrimary: boolean;
}

export const AccountPickerFooter: React.FC<AccountPickerFooterProps> = ({
    onUseAccount,
    isUseAccountButtonDisabled,
    isUseAccountButtonPrimary,
}) => {
    return (
        <ModalFooterContainer data-testid="account-picker-footer">
            <AccountPickerFooterWrapper
                style={{
                    justifyContent: "flex-end",
                    width: "100%",
                }}
            >
                <Button
                    data-testid="use-account"
                    type="submit"
                    variant={isUseAccountButtonPrimary ? "primary" : "default"}
                    onClick={onUseAccount}
                    disabled={isUseAccountButtonDisabled}
                >
                    Use Account
                </Button>
            </AccountPickerFooterWrapper>
        </ModalFooterContainer>
    );
};
